import { useOrganisationBasketContext } from "@/contexts/organisations/OrganisationBasketContext";

import BasketErrorModal from "./BasketErrorModal";

export default function AddOnErrorModal() {
  const {
    hasAddonError,
    acknowledgedBasketAddonErrorModal,
    setAcknowledgedBasketAddonErrorModal
  } = useOrganisationBasketContext();

  return (
    <BasketErrorModal
      explanation={`Oops! Some items in your basket include add-ons, reports or clinic options. To continue with a stock basket, please remove these items first. `}
      show={!!hasAddonError && !acknowledgedBasketAddonErrorModal}
      onClose={() => {
        setAcknowledgedBasketAddonErrorModal(true);
      }}
    />
  );
}
